import generatedKnowledgeIndex from './geoKnowledge.index.generated.json';
import { applyGeoKnowledgeVisualAssets, hasGeoKnowledgeVisualCover } from './geoVisualAssets';

export interface GeoKnowledgeIndexArticle {
  id: string;
  title: string;
  summary: string;
  date: string;
  category: string;
  cover: string;
  sourceUrl: string;
  route: string;
  reused: boolean;
}

const payload = generatedKnowledgeIndex as {
  migratedAt: string;
  source: string;
  category: {
    slug: string;
    title: string;
    count: number;
  };
  articles: GeoKnowledgeIndexArticle[];
};

export const geoKnowledgeArticles = payload.articles.map(applyGeoKnowledgeVisualAssets);
export const geoKnowledgeCategory = payload.category;
export const geoKnowledgeMigratedAt = payload.migratedAt;
export { hasGeoKnowledgeVisualCover };

export const getGeoKnowledgeArticle = (id?: string) =>
  geoKnowledgeArticles.find((article) => article.id === id);

export const getGeoKnowledgeArticlePath = (article: GeoKnowledgeIndexArticle) => article.route;
